import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ResultsView } from "@/views";

export const Route = createFileRoute("/_dashboard/results")({
  component: ResultsPage,
});

function ResultsPage() {
  const navigate = useNavigate();

  const handleChartClick = (code: string) => {
    navigate({ to: "/charts", search: { code } });
  };

  return <ResultsView onChartClick={handleChartClick} />;
}
